import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
import config from "@/config";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    query: {},
    typecb: "email",
    jobdetaildata: "",
    projects: "",
    agency: "",
    serverUrl: config.serverUrl,
    userid: "",
    memberid: "",
    registerStatus: null,
    registerType: null,
    type: [
      "บุคคลทั่วไป",
      "บริษัทจำกัด/บมจ",
      "หจก",
      "สหกรณ์",
      "มูลนิธิ",
      "ธนาคาร",
      "สภา/สมาคม",
      "รัฐวิสาหกิจ/หน่วยงานรัฐ",
      "มหาวิทยาลัย",
      "สถานศึกษาอื่นๆ",
      "วิสาหกิจชุมชน",
      "กองทุนหมู่บ้าน",
      "กลุ่มออมทรัพย์",
      "สภา/องค์กรชุมชน",
      "นิคมอุตสาหกรรม",
      "Social Enterprise",
      "องค์กรปกครองส่วนท้องถิ่น",
      "โรงแรมขนาดเล็ก",
    ],
    type2: [
      "บุคคลทั่วไป",
      "มี Tax ID",
      "บริษัทจำกัด/บมจ",
      "หจก",
      "สหกรณ์",
      "มูลนิธิ",
      "ธนาคาร",
      "สภา/สมาคม",
      "รัฐวิสาหกิจ/หน่วยงานรัฐ",
      "มหาวิทยาลัย",
      "สถานศึกษาอื่นๆ",
      "วิสาหกิจชุมชน",
      "กองทุนหมู่บ้าน",
      "กลุ่มออมทรัพย์",
      "สภา/องค์กรชุมชน",
      "นิคมอุตสาหกรรม",
      "Social Enterprise",
      "องค์กรปกครองส่วนท้องถิ่น",
      "โรงแรมขนาดเล็ก",
    ],
    membertype: [],
    input: {},
    profiledata: [],
    progress: null,
    memberData: null,
    windowW: 0,
    windowH: 0,
    dpSize: "", /// displaySize
    consent: [],
    sessiontoken: "",
  },
  mutations: {
    ["UPDATE_INPUT"](state, data) {
      state.input = data;
    },
    ["UPDATE_VIEW"](state, data) {
      state.query.view = data;
    },
  },
  actions: {
    setinput({ commit }, payload) {
      commit("UPDATE_INPUT", payload);
    },
    setview({ commit }, payload) {
      commit("UPDATE_VIEW", payload);
    },
    sendMessage({ state, dispatch }, message) {
      return new Promise(async (resolve) => {
        if (await window.liff.isInClient()) {
          try {
            await window.liff.sendMessages([
              {
                text: message,
                type: "text",
              },
            ]);
            resolve();
          } catch (error) {
            let result = await dispatch("sendMessageByQuota", message);
            if (!result) {
              alert(JSON.stringify(error));
              alert(JSON.stringify(error.message));
            } else {
              resolve();
            }
          }
        } else {
          await dispatch("sendMessageByQuota", message);
          resolve();
        }
      });
    },
    async sendMessageByQuota({ state }, message) {
      var url = state.serverUrl + "zwiz-pushmsg-webbrowser";
      var data = {
        pageid: state.query.pageid,
        userid: state.userid,
        message,
      };
      let response = await axios.post(url, data, {
        headers: {
          AUTHORIZATION: "Bearer xxx xxx",
        },
      });
      if (response.data.responsecode == 200) {
        return true;
      } else {
        if (response.data.reason) {
          await this.$swal.fire({
            text: response.data.reason,
          });
        }
      }
    },
    depamemberinfo({ state, dispatch }, payload) {
      return new Promise((resolve) => {
        var data = {
          pageid: state.query.pageid,
          memberid: state.memberid,
          ...payload,
          membertype: state.input.membertype,
          membertype_id: state.input.membertype_id,
          status: "confirm",
        };
        data.userid = state.userid
          ? state.userid
          : `${state.profile.userId}__${state.query.pageid}`;
        axios
          .put(state.serverUrl + "webview/editDepaMemberInfo", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              await Swal.fire({
                icon: "success",
                text: "ยืนยันตัวตนสำเร็จ",
              });
              await dispatch("sendMessage", "ยืนยันตัวตนสำเร็จ");
              window.liff.closeWindow();
            } else if (response.data.responsecode == 400) {
              await Swal.fire({
                text: response.data.reason,
              });
              window.liff.closeWindow();
            } else if (response.data.responsecode == 300) {
              var reason = response.data.reason;
              if (reason == "destination service no content") {
                reason = "ข้อมูลไม่ถูกต้องกรุณากรอกใหม่อีกครั้ง";
              }
              await Swal.fire({
                text: reason,
              });
            } else if (response.data.responsecode == 204) {
              var reason = response.data.reason;
              await Swal.fire({
                text: reason,
              });
            }
            resolve(response.data.responsecode);
          });
      });
    },
    depamemberinfo_verification({ state, dispatch }, payload) {
      return new Promise((resolve) => {
        var data = {
          pageid: state.query.pageid,
          memberid: state.memberid,
          ...payload,
          membertype: state.input.membertype,
          membertype_id: state.input.membertype_id,
          verification: state.input.verification,
          status: "confirm",
        };

        data.userid = state.userid
          ? state.userid
          : `${state.profile.userId}__${state.query.pageid}`;
        axios
          .put(state.serverUrl + "depamemberinfo", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              await Swal.fire({
                icon: "success",
                text: "ยืนยันตัวตนสำเร็จ",
              });
              await dispatch("sendMessage", "ยืนยันตัวตนสำเร็จ");
              window.liff.closeWindow();
            } else if (response.data.responsecode == 400) {
              await Swal.fire({
                text: response.data.reason,
              });
              window.liff.closeWindow();
            } else if (response.data.responsecode == 300) {
              var reason = response.data.reason;
              if (reason == "destination service no content") {
                reason = "ข้อมูลไม่ถูกต้องกรุณากรอกใหม่อีกครั้ง";
              }
              await Swal.fire({
                text: reason,
              });
            } else if (response.data.responsecode == 204) {
              var reason = response.data.reason;
              await Swal.fire({
                text: reason,
              });
            }
            resolve(response.data.responsecode);
          });
      });
    },
  },
  modules: {},
});
